import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AdvancedBookingsPage } from "../../pages/advanced-bookings/advanced-bookings";
import { ServicesPage } from "../../pages/services/services";
import moment from "moment";
import {
    ActionSheetController,
    AlertController,
    Content,
    Events,
    ModalController,
    NavController,
    NavParams,
    PopoverController,
    Tabs
} from "ionic-angular";
import { ProfileLoginPage } from "../../pages/profile-login/profile-login";
import { CancelledBookingsPage } from "../../pages/cancelled-bookings/cancelled-bookings";
import { DurationPipe } from "../../pipes/duration/duration";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { AdvancedBookingsTimePage } from "../../pages/advanced-bookings-time/advanced-bookings-time";
import { TeamServiceProvider } from "../../providers/team-service/team-service";
import { StaffServiceProvider } from "../../providers/staff-service/staff-service";
import { ServiceQuantityModal } from '../../pages/service-quantity-modal/service-quantity-modal';
import { TimezoneProvider } from '../../providers/timezone/timezone';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { switchMap, concatMap } from 'rxjs/operators';
import { ServiceSummaryPage } from '../../pages/service-summary/service-summary';
import { BarberBookingNewPage } from '../../pages/barber-booking-new/barber-booking-new';


/**
 * Generated class for the ShopQueueComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'shop-queue',
    templateUrl: 'shop-queue.html'
})
export class ShopQueueComponent {
    @ViewChild(Content) content: Content;
    @Input() isRefresh: boolean;
    @Input() shop: any;
    @Input() shopType: 'coffeShop' | 'barberShop';
    @Output() makeAdvanceBooking = new EventEmitter();
    @Output() selectUser = new EventEmitter();
    @Output() selectHoursEvent = new EventEmitter();
    @Output() isScrollContent = new EventEmitter();
    errors: {};
    loading: boolean;
    tuid: any;
    timezone: any;
    selectedIndex: any = null;

    selectedBarber: any;
    categories: any[] = [];
    selectedCategoryIndex: number = 0;
    byStaff: boolean;
    selectedServicesCount: number = 0;

    private selectedPromorSerivces: number = 0;
    selectedServicesDuration: number = 0;
    isAdditionalService: boolean = false;
    public promo_products: any = { promo_product_limit: 0, promo_product_count: 0 };
    public poromoProductCount: number;
    public isContinue: boolean = true;
    currencySymbol: string;
    selected: any = {};
    advanceBookings: any[] = [];

    public timeLoading: boolean = false;
    public errorMessage: string = '';
    public timeSection: boolean = false;
    ContinueBtn: any = "Next";
    todayCancelledBooking: any[] = [];
    todayBooking: any[] = [];
    currentTimeZone: any;
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public durationPipe: DurationPipe,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        private events: Events,
        private actionSheetCtrl: ActionSheetController,
        public popoverCtrl: PopoverController,
        public modalCtrl: ModalController,
        public teamService: TeamServiceProvider,
        public staffService: StaffServiceProvider,
        private tz: TimezoneProvider,
        public coffeShopService: CoffeShopService,
        public alertCtrl: AlertController) {
        this.loading = true;
        this.tuid = localStorage.getItem('tuid');
        // this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    ngOnInit() {
        this.teamService.isRefresh.subscribe((res) => {
            if (res) {
                this.selectedIndex = null;
                this.selectedCategoryIndex = 0;
                this.timeSection = false;
                this.coffeShopService.bookingTimes = [];
                this.coffeShopService.bookingDates = [];
                this.coffeShopService.selectedDate = "";
                this.coffeShopService.selectedTime = "";
                this.selected = {};
                this.selected.services = [];
                this.selected.totalCost = 0;
                this.selected.availableTime = 0;
                this.selectedServicesCount = 0;
                this.selectedPromorSerivces = 0;
                this.selectedServicesDuration = 0;
                this.selectedBarber = null;
                this.categories = [];
                this.errorMessage = '';
                // this.getCategories().then(categories => {
                //     this.loading = false;
                // });
            }
        });
        
        if (this.shop) {
            this.currentTimeZone = new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone }));

            let filteredUsers = [];
            for (var i = 0; i < this.shop.users.length; i++) {
                let user = this.shop.users[i];
                if (user.today_advanced_bookings && user.today_advanced_bookings.length > 0) {
                    user.today_advanced_bookings = user.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
                }
                filteredUsers.push(user);
            }
            this.shop.users = filteredUsers;
            this.tz.timezone(this.shop).then((currencySymbol: string) => {
                this.currencySymbol = currencySymbol;
            });
        }
    }

    ngOnDestroy() {
        this.selectedIndex = null;
        this.selectedCategoryIndex = 0;
        this.timeSection = false;
        this.coffeShopService.bookingTimes = [];
        this.coffeShopService.bookingDates = [];
        this.errorMessage = '';
    }

    isBarberHolidayToday(barber) {
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone }));
        const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
        if (barber.hours && barber.hours[today_day] == null) {
            return true;
        }
        return false;
    }

    public selectHoursComponentEvent(event): void {
        this.selectHoursEvent.emit(event);
    }
    openAdvancedBookingPage() {
        if (this.shopType === 'coffeShop') {
            this.makeAdvanceBooking.emit(this.shopType)
            return;
        }
        this.tuid = localStorage.getItem('tuid');

        if (!this.tuid) {
            this.setReferral(0, 5);
            return;
        }

        if (localStorage.getItem('tuid')) {
            // this.navCtrl.push(AdvancedBookingsPage, {
            //     shop: this.shop
            // })
            this.navCtrl.push(BarberBookingNewPage, {
                shop: this.shop,
                byStaff: null,
                guestUser: null,
                isAdvanceBooking: true
            });
        } else {
            this.navCtrl.push(ProfileLoginPage, {
                shop: this.shop
            })
        }
    }

    selectServiceType(barber) {
        if (this.shopType === 'coffeShop') {
            this.selectUser.emit(this.shopType)
            return;
        }

        // Do nothing if the queue is full
        if (this.isBarberAvailableAndQueueFull(barber)) return;
        if (this.isBarberQueueFull(barber)) return;

        this.tuid = localStorage.getItem('tuid');

        if (!this.tuid) {
            this.setReferral(0, 5);
            return;
        }

        let actionSheetButtons: any = [
            {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                }
            }
        ];

        let advancedBookingButton = {
            text: 'Advanced Booking',
            handler: () => {

                let todaysDate = moment(new Date()).format('DD/MM/YYYY');
                this.navCtrl.push(AdvancedBookingsTimePage, {
                    date: todaysDate,
                    shop: this.shop,
                    barber: barber,
                    byStaff: null
                });

            }
        };

        if (this.barberHasAdvancedBookingHoursForToday(barber)) {
            actionSheetButtons.unshift(advancedBookingButton);
        }

        let standardBookingButton = {
            text: 'Join the Queue',
            handler: () => {
                this.openServices(barber);
            }
        };

        if (!this.isBarberUnavailable(barber)) {
            actionSheetButtons.unshift(standardBookingButton);
        }

        let actionSheet = this.actionSheetCtrl.create({
            title: 'What would you like to do today?',
            buttons: actionSheetButtons
        });

        actionSheet.present();

    }

    barberHasAdvancedBookingHoursForToday(barber) {
        if (barber.advanced_booking_hours) {
            let dayOfWeek = moment(new Date()).format('dddd').toLowerCase();
            if (barber.advanced_booking_hours[dayOfWeek]) {
                return true;
            }
        }
        return false;
    }

    openServices(barber) {
        this.tuid = localStorage.getItem('tuid');

        if (!this.tuid) {
            this.setReferral(0, 5);
            return;
        }

        if (!this.isBarberUnavailable(barber) && !this.isBarberQueueFull(barber)) {
            if (barber.todays_cancelled_bookings.length) {
                this.navCtrl.push(CancelledBookingsPage, {
                    barber: barber,
                    shop: this.shop
                })
            } else {
                this.navCtrl.push(ServicesPage, {
                    barber: barber,
                    shop: this.shop
                })
                // let servicesPageModal = this.modalCtrl.create(ServicesPage, {
                //   barber: barber,
                //   shop: this.shop
                // });
                // servicesPageModal.present();
            }
        }
    }

    showBarber(barber, index) {
        if (!barber.current_active_team) return false;
        if (barber.holidays.holidayToday) return false;
        if (barber.current_active_team !== this.shop.id) return false;
        return true;
    }

    isCurrentlyActiveBarber(barber, i) {
        return this.staffService.isCurrentlyActiveStaff(this.shop.id, barber, i);
    }

    isBarberUnavailable(barber) {
        return this.staffService.isStaffUnavailable(this.shop.id, barber);
    }

    isBarberQueueFull(barber) {
        return this.staffService.isStaffQueueFull(barber, this.shop.id);
    }

    isBarberAvailableAndQueueFull(barber) {
        return this.staffService.isStaffAvailableAndQueueFull(barber, this.shop.id);
    }

    canBookInAdvance() {
        if (this.shop.allow_advanced_booking && this.shop.settings.num_days_bookings_can_be_made_in_advance > 0) return true;
        return false;
    }

    getQueueClass(barber, i) {
        if (this.isCurrentlyActiveBarber(barber, i)) return 'card-queue--highlight';
        if (this.isBarberAvailableAndQueueFull(barber)) return 'card-queue--full';
        if (this.isBarberQueueFull(barber)) return 'card-queue--full';
        if (this.isBarberUnavailable(barber)) return '';
        return '';
    }

    openingTime(hours, day) {
        if (hours && hours[day] !== null) {
            return this.formatTime(hours[day]) + ' - ' + this.formatTime(hours[`${day}_close`])
        }

        return 'Closed';
    }

    formatTime(time) {
        return moment(time, 'HH:mm:ss').format('h:mma');
    }

    ngOnChanges(changes) {
        if (changes.shop) {
            if (this.shop.users) {
                this.shop = changes.shop.currentValue;
                this.loading = false;
            }
        }
    }

    setReferral(referral, tab) {
        localStorage.setItem('refer', String(referral));
        let tabBar: Tabs = this.navCtrl.parent;
        tabBar.select(tab);
    }

    async selectServices(barber, index) {
        if (!localStorage.getItem('tuid')) {
            this.navCtrl.push(ProfileLoginPage, {
                shop: this.shop
            });
            return;
        }

        this.selectedIndex = index;
        this.timeSection = false;
        this.selectedCategoryIndex = 0;
        this.coffeShopService.selectedDate = "";
        this.coffeShopService.selectedTime = "";
        this.selected = {};
        this.selected.services = [];
        this.selected.totalCost = 0;
        this.selected.availableTime = 0;
        this.selectedServicesCount = 0;
        this.selectedPromorSerivces = 0;
        this.selectedServicesDuration = 0;

        this.selectedBarber = barber;
        this.todayCancelledBooking = [];
        this.todayBooking = [];

        await this.getavailableDuration();
        await this.getAdvAvailableDuration();
        if (this.todayBooking.length > 0) {
            this.todayBooking = this.todayBooking.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));
        }
        this.categories = [];
        this.getCategories().then(categories => {
            this.loading = false;
        });
    }

    getTeamId() {
        return this.shop.id ? this.shop.id : localStorage.getItem('currentTeamId');
    }

    private deleteIconFromName(services: any[]): any[] {
        services.sort((a, b) => Number(a.order) - Number(b.order));
        return services.map((service: any) => {
            const latters: string[] = service.name.split('').filter((latter: string) => latter !== "\ud83c" && latter !== "\udd93");
            latters[latters.length - 1] === ' ' ? latters.pop() : null;
            service.name = latters.join('');
            return service;
        });
    }

    selectCategory(categoryIndex) {
        this.selectedCategoryIndex = categoryIndex;
    }

    getCategories() {
        return new Promise((resolve, reject) => {
            let teamId = this.getTeamId();
            let endpoint = `/teams/${teamId}/members/${this.selectedBarber.id}/active-categories-with-services?tuid=${this.tuid}&isStaff=false`;
            this.http.get(endpoint).subscribe(
                (categories: any) => {
                    categories.forEach((category: any) => {
                        if (category.services && category.services.length) {
                            category.services = this.deleteIconFromName(category.services);
                        }
                    });
                    this.categories = categories;
                    this.isScrollContent.emit(true)
                    resolve(categories);
                },
                (error) => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    reject(error);
                },
                () => { },
            );
        });
    }

    chooseServiceQuantity(service) {
        if (service.disabled && !this.byStaff) return;
        let serviceQuantityModal = this.popoverCtrl.create(ServiceQuantityModal, {
            service: service,
            selectedServicesCount: this.selectedServicesCount,
            selectedServicesDuration: this.selectedServicesDuration,
            availableServiceDuration: null,
            //   availableServiceDuration: (this.booking && this.booking.available_duration ? this.booking.available_duration : null),
            currencySymbol: this.currencySymbol,
            byStaff: this.byStaff,
            shopType: 'barber',
            cssClass: 'service-qty-modal',
        }, {
            enableBackdropDismiss: false
        });
        serviceQuantityModal.present();
        serviceQuantityModal.onWillDismiss(_ => {
            this.setSelectedServices();
            this.setSelectedServicesCount();
            this.isScrollContent.emit(true);
        });
    }

    setSelectedServices() {
        this.selected = {};
        this.selected.services = [];
        this.selected.totalCost = 0;
        this.selected.availableTime = 0;
        this.categories.forEach(category => {
            category.services.forEach(service => {
                if (!service.selected) return;
                this.selected.services.push(service);
            })
        });
    }

    setSelectedServicesCount() {
        this.selectedServicesCount = 0;
        this.selectedPromorSerivces = 0;
        this.selectedServicesDuration = 0;

        this.categories.forEach(category => {
            category.selectedServicesCount = 0;
            category.services.forEach(service => {

                if (service.selected && service.quantity > 0) {
                    if (service.price <= 0 && service.promo_product == 1) {
                        this.selectedPromorSerivces += service.quantity;
                    }
                    category.selectedServicesCount += service.quantity;
                    this.selectedServicesCount += service.quantity;
                    this.selectedServicesDuration += (service.quantity * service.duration);
                }
            })
        });

        this.poromoProductCount = this.promo_products.promo_product_limit - this.promo_products.promo_product_count - this.selectedPromorSerivces
        this.isContinueFunction();
    }

    isContinueFunction() {
        this.ContinueBtn = "Next"
        if (this.loading || this.selectedServicesCount < 1) {
            return this.isContinue = true;
        } else {
            if (this.poromoProductCount < 0) {
                return this.isContinue = true;
            }
            return this.isContinue = false;
        }
    }

    async openAdditionalServiceSummaryPage() {
        if (!this.coffeShopService.selectedDate || !this.coffeShopService.selectedTime) { //this.coffeShopService.user.advanced_booking_hours && (!this.coffeShopService.selectedDate || !this.coffeShopService.selectedTime)
            this.timeSection = true;
            this.chooseDateAndTime();
            // this.ContinueBtn = "Checkout"
            return;
        }

        let requestedBookingDate = moment(moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY') + ' ' + this.coffeShopService.selectedTime, 'DD-MM-YYYY HH:mm');
        let advancedBooking: any = {
            date: moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY'),
            time: this.coffeShopService.selectedTime,
            requested_booking_date_string: requestedBookingDate.format('dddd Do MMMM YYYY') + ' at ' + requestedBookingDate.format('h:mm a')
        }

        // let bookingType = 1;
        // let selectedDate = moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY');
        // let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);

        // if (moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY') == nowMoment.toLocaleDateString()) {
        //     bookingType = 1;
        // } else {
        //     bookingType = 2;
        // }

        let bookingType = 1;
        let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
        let selectedTime = this.coffeShopService.selectedTime.split(':')
        let datese = new Date(this.coffeShopService.selectedDate).setHours(Number(selectedTime[0]), Number(selectedTime[1]));

        if (new Date(datese).getTime() <= nowMoment.getTime()) {
            bookingType = 1;
        } else {
            bookingType = 2;
        }

        let booking = null;
        let selectedDate = moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY');
        let nowDate = moment(nowMoment).format('DD/MM/YYYY');
        let isadvance = false;

        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone }));
        if (this.selectedBarber.todays_cancelled_bookings.length > 0 && this.selectedBarber.current_chair_time_with_cancelled
            && selectedDate === nowDate) {
            await this.appendServicesToBooking();
            for (var element of this.selectedBarber.todays_cancelled_bookings) {
                let differenceAdv = new Date(this.currentTimeZone).getTime() - new Date(element.estimated_booking_time).getTime();
                differenceAdv = Math.ceil(differenceAdv / 60000);
                differenceAdv = element.available_duration - differenceAdv;
                let endTime = new Date(new Date(element.estimated_booking_time).getTime() + element.available_duration * 60 * 1000);

                if (this.selectedServicesDuration <= element.available_duration
                    && (moment(element.estimated_booking_time).format('HH:mm') == this.coffeShopService.selectedTime)
                    && (new Date(timezoen).getTime() <= new Date(element.estimated_booking_time).getTime()
                        || this.selectedServicesDuration <= differenceAdv)) {
                    booking = element;
                    // If not working then comment below line 
                    bookingType = 1;
                    break;
                } else if (this.selectedServicesDuration <= differenceAdv &&
                    (new Date(datese).getTime() >= new Date(element.estimated_booking_time).getTime() && new Date(datese).getTime() < new Date(endTime).getTime())) {
                    booking = element;
                    isadvance = true;
                }
            }

            if (typeof (this.selectedBarber.current_chair_time_with_cancelled) != 'undefined'
                && this.selectedBarber.current_chair_time_with_cancelled != null
                && this.selectedBarber.current_chair_time_with_cancelled.toString().trim() != '' && this.selectedBarber.todays_cancelled_bookings.length == 1) {

                if (this.selectedBarber.current_chair_time_with_cancelled.slice(-2) == 'PM') {
                    this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.toUpperCase();
                    let actualSelectedTime = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.includes('AM') ?
                        this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('AM').join(' AM')) :
                        this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('PM').join(' PM'));

                    if (actualSelectedTime == this.coffeShopService.selectedTime) {
                        // bookingType = 1;
                    } else {
                        booking = null;
                    }
                } else {

                    this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.toUpperCase();
                    let actualSelectedTime = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.includes('AM') ?
                        this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('AM').join(' AM')) :
                        this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('PM').join(' PM'));



                    // let time = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.substring(0, this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.length - 2);
                    // let times = time.split(":");
                    // let hr = Number(times[0]) > 9 ? ((Number(times[0]) - 12).toString().length == 1 ? ('0' + (Number(times[0]) - 12)) : (Number(times[0]) - 12)) : ('0' + (Number(times[0])));
                    // let actualSelectedTime = hr + ':' + times[1];
                    if (actualSelectedTime == this.coffeShopService.selectedTime) {
                        // bookingType = 1;
                    } else {
                        if (!isadvance)
                            booking = null;
                    }
                }
            }
        }

        const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
        if (booking == null && !isadvance && nowDate == selectedDate && (this.coffeShopService.user.advanced_booking_hours == null || this.coffeShopService.user.advanced_booking_hours[`${today_day}`] == null)) {
            bookingType = 1;
        }

        // console.log({
        //     services: this.selected,
        //     shop: this.shop,
        //     barber: this.selectedBarber,
        //     bookingType: bookingType,
        //     advancedBooking: bookingType == 2 && !booking ? advancedBooking : null,
        //     byStaff: this.byStaff,
        //     fromLobby: false,
        //     fromStaffPanel: false,
        //     booking: bookingType == 1 && booking ? booking : null,
        //     guestUser: null,
        // });

        this.navCtrl.push(ServiceSummaryPage, {
            services: this.selected,
            shop: this.shop,
            barber: this.selectedBarber,
            bookingType: bookingType,
            advancedBooking: bookingType == 2 && !booking ? advancedBooking : null,
            byStaff: this.byStaff,
            fromLobby: false,
            fromStaffPanel: false,
            // booking: bookingType == 1 && booking ? booking : null,
            booking: booking ? booking : null,
            guestUser: null,
        });
    }

    private convertTZ(date: string | Date, tzString: string): Date {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
    }

    public async chooseDateAndTime(): Promise<void> {
        this.coffeShopService.showChooseDate = true;
        this.timeLoading = true;
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        // setTimeout(() => this.content.scrollToBottom(), 0);
        this.coffeShopService.getCoffeShop(this.shop.id)
            .pipe(switchMap((shop: any) => {
                this.proccessShop(shop);
                // if (this.coffeShopService.user.advanced_booking_hours) {
                return this.coffeShopService.advancedBookingRequest({ date: '', available: true }, true)
                    .pipe(switchMap((barbers) => {
                        this.proccessAdanceBookingRequest({ date: '', available: true }, barbers, null);
                        this.openCalendar();

                        if (this.coffeShopService.bookingDates.length) {
                            this.coffeShopService.selectedDate = this.coffeShopService.bookingDates.find((date) => date.available).date as any;
                            const formattedDate = this.coffeShopService.requestDateFormatter(this.coffeShopService.selectedDate);
                            return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(formattedDate, this.selectedBarber)])
                        } else {
                            return forkJoin([of(barbers), of(null)])
                        }
                    }))
                // } else {
                //     return of(shop);
                // }
            })).subscribe(async ([barbers, times]: any) => {
                const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone }));
                if (times == null) {
                    times = [];
                }

                if (times && times.length > 0) {
                    for (let Tindex = 0; Tindex < times.length; Tindex++) {
                        const element = times[Tindex];

                        if (element.available && times[times.length - 1] !== element) {
                            let duration = element.time_difference_in_minutes;

                            for (let index = Tindex + 1; index < times.length; index++) {
                                if (times[index].available) {
                                    duration += times[index].time_difference_in_minutes;
                                } else {
                                    break;
                                }
                            }

                            element.available = duration >= this.selectedServicesDuration;
                        } else if (times[times.length - 1] === element && element.available == true) {
                            element.available = element.time_difference_in_minutes >= this.selectedServicesDuration;
                        }
                    }
                }

                // try {
                //     await this.getBarberWithBookings().then(
                //         (res: any) => {
                //             this.advanceBookings = res;
                //             if (this.advanceBookings && this.advanceBookings.length > 0) {
                //                 this.advanceBookings = this.advanceBookings.sort((a: any, b: any) => {
                //                     return new Date(a.booking.requested_booking_time).getTime() - new Date(b.booking.requested_booking_time).getTime();
                //                 });

                //                 for (let index = 0; index < this.advanceBookings.length; index++) {
                //                     if (index != (this.advanceBookings.length - 1)) {
                //                         let upcomingadv = this.advanceBookings[index + 1].booking.estimated_booking_time ? new Date(this.advanceBookings[index + 1].booking.estimated_booking_time) : new Date(this.advanceBookings[index + 1].booking.requested_booking_time);

                //                         let currentAdVTime = this.advanceBookings[index].booking.estimated_booking_time ? this.advanceBookings[index].booking.estimated_booking_time : this.advanceBookings[index].booking.requested_booking_time;
                //                         let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.advanceBookings[index].booking.getDuration * 60000);
                //                         let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                //                         differenceAdv = differenceAdv / 60000;
                //                         if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && new Date(newdateAdvc).getTime() > new Date(timezoen).getTime()) {
                //                             times.push({ date: moment(newdateAdvc).format('YYYY-MM-DD HH:mm:ss'), available: true });
                //                         }
                //                     }
                //                 }
                //             }
                //         });
                // } catch (error) {

                // }

                // if ((times && times.length > 0) && this.selectedServicesDuration > this.shop.settings.advanced_bookings_time_interval) {
                //     let nextSlots = this.selectedServicesDuration / this.shop.settings.advanced_bookings_time_interval;
                //     let nextSlotsArray = nextSlots.toString().split(".");
                //     let noofSlots: number = 1;
                //     if (nextSlotsArray[1]) {
                //         noofSlots = (Number(nextSlotsArray[0]) + 1);
                //     } else {
                //         noofSlots = Number(nextSlotsArray[0]);
                //     }

                //     times.forEach((element, index) => {
                //         if (element.available && times[times.length -1] !== element) {
                //             let duration = element.time_difference_in_minutes;
                //             let nextElements = [];
                //             for (let t = 1; t < noofSlots; t++) {
                //                 if (times[(index + t)]) {
                //                     nextElements.push(times[(index + t)].available);
                //                     // duration+= times[(index + t)].available ? times[(index + t)].time_difference_in_minutes : 0;
                //                 } else {
                //                     nextElements.push(false);
                //                 }
                //             }
                //             console.log("nextElements",nextElements);
                //             element.available = nextElements.some(res => res == false) ? false : true;
                //             // element.available = duration >= this.selectedServicesDuration ? true : false;
                //         }
                //     });
                // }


                // if ((times && times.length > 0) && this.todayBooking.length > 0) {
                //     times.forEach((element, index) => {
                //         this.todayBooking.forEach(todayBookings => {
                //             if (times[index + 1] && new Date(element.date) <= new Date(todayBookings.estimated_booking_time) && new Date(times[index + 1].date) >= new Date(todayBookings.estimated_booking_time)) {
                //                 element.available = false;
                //             }

                //             let newdate = new Date(new Date(new Date(todayBookings.estimated_booking_time)).getTime() + todayBookings.available_duration * 60000);
                //             if (times[index + 1] && new Date(element.date) <= (new Date(newdate)) && new Date(times[index + 1].date) >= new Date(newdate)) {
                //                 element.available = false;
                //             }
                //         });
                //     });
                // }

                if (times && times.length > 0) {
                    // times = this.CheckLastSlots(times);
                    // if(now === new Date(this.coffeShopService.selectedDate)){
                    //     times = this.CheckLastSlots(times);
                    // }
                    times = times.sort((a, b) => a.date.localeCompare(b.date));
                    times = this.removeDuplicates(times);
                }
                if (this.coffeShopService.bookingDates.length && barbers && times) {
                    this.proccessAdanceBookingRequest(this.coffeShopService.bookingDates[0], barbers, times);
                }
                if (this.coffeShopService.coffeShop.has_active_barbers) {
                    // this.checkBarberIsFree();
                }
                this.isScrollContent.emit(true);
                this.timeLoading = false;
                this.loading = false;
            }, (error: HttpErrorResponse) => {
                this.timeLoading = false;
                this.loading = false;
            });
    }

    getBarberWithBookings() {
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        if (this.coffeShopService.selectedDate == null || this.coffeShopService.selectedDate == "") {
            this.coffeShopService.selectedDate = now as any;
        }

        return new Promise((resolve, reject) => {
            this.http.get(`/getAdvBooking/${this.selectedBarber.id}`,
                { params: { bookingDate: moment(this.coffeShopService.selectedDate).format("DD/MM/YYYY") } }
            ).subscribe((barber: any) => {
                resolve(barber);
            }, error => {
                resolve(null);
            })
        });
    }

    public CheckLastSlots(times): any {
        let isLastSlotsBooked: boolean = false;
        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
        const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
        let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);

        const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
            `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;

        const barmen_adv_time_end = this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`] ?
            `${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[0]}:${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[1]}` : null;

        if ((barmen_time_end || barmen_adv_time_end) && times.length > 0) {
            if (!times[times.length - 1].available) {
                if (this.selectedBarber.today_advanced_bookings.length > 0) {
                    let lastElement = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                    let currentAdVTime = lastElement.estimated_booking_time ? lastElement.estimated_booking_time : lastElement.requested_booking_time;
                    let newdate = new Date(new Date(new Date(currentAdVTime).setSeconds(0)).getTime() + lastElement.getDuration * 60000);
                    let end = barmen_time_end.split(":");
                    const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));

                    let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                    differenceAdv = differenceAdv / 60000;
                    if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                        isLastSlotsBooked = true;
                        times.push({ date: moment(newdate).format('YYYY-MM-DD HH:mm:ss'), available: true });
                        // times.push({ date: new Date(newdate), available: true });
                        //return times;
                    }

                    let isExistLastSlotBooking = this.selectedBarber.today_advanced_bookings.findIndex(item => new Date(item.requested_booking_time).getTime() == new Date(times[times.length - 1].date).getTime());
                    if (isExistLastSlotBooking !== -1) {
                        isLastSlotsBooked = true;
                    }
                }

                if (barmen_adv_time_end && barmen_time_end) {
                    let advEnd = barmen_adv_time_end.split(":");
                    const BarberAdvEndTime = new Date(nowMoment).setHours(Number(advEnd[0]), Number(advEnd[1]));

                    let end = barmen_time_end.split(":");
                    const BarberEndTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));

                    // Check advance hours less then barber reaular hours 
                    if (new Date(BarberAdvEndTime).getTime() > new Date(BarberEndTime).getTime()) {
                        const endTime = new Date(nowMoment).setHours(Number(advEnd[0]), Number(advEnd[1]));
                        const lastSlot = new Date(times[times.length - 1].date);

                        let differenceAdv = new Date(endTime).getTime() - new Date(lastSlot).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && !isLastSlotsBooked) {
                            times[times.length - 1].available = true;
                            return times;
                        }
                        return times;
                    }
                    // return times;
                }

                if (barmen_time_end) {
                    let end = barmen_time_end.split(":");
                    const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                    const lastSlot = new Date(times[times.length - 1].date);
                    if (new Date(lastSlot).getTime() > new Date(nowMoment).getTime()) {
                        let differenceAdv = new Date(endTime).getTime() - new Date(lastSlot).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && !isLastSlotsBooked) {
                            times[times.length - 1].available = true;
                            return times;
                        }
                    }
                }
            }

        }

        return times;
    }

    private proccessShop(shop): void {
        if (shop) {
            let filteredUsers = [];
            for (var i = 0; i < shop.users.length; i++) {
                let user = shop.users[i];
                if (user.today_advanced_bookings && user.today_advanced_bookings.length > 0) {
                    user.today_advanced_bookings = user.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
                }
                filteredUsers.push(user);
            }
            shop.users = filteredUsers;
        }
        this.coffeShopService.bookingDates = [];
        this.coffeShopService.bookingTimes = [];
        this.selectedBarber = shop.users.filter((barber) => barber.id == this.selectedBarber.id)[0];
        this.coffeShopService.shop = shop;
        this.coffeShopService.user = this.selectedBarber;
        this.coffeShopService.coffeShop = shop;
        this.getFirstBookingDate();
        this.getLastBookingDate();
    }

    getLastBookingDate() {
        let daysBookingCanBeMadeInAdvance = this.coffeShopService.shop.settings ? this.coffeShopService.shop.settings.num_days_bookings_can_be_made_in_advance : 7;
        this.coffeShopService.lastBookingDate = moment().add(daysBookingCanBeMadeInAdvance, 'days');
        this.coffeShopService.lastBookingDate = new Date(this.coffeShopService.lastBookingDate.get('year'), this.coffeShopService.lastBookingDate.get('month'), this.coffeShopService.lastBookingDate.get('date'));
    }
    getFirstBookingDate() {
        let date = moment(this.coffeShopService.shop.first_advanced_booking_date, 'YYYY-MM-DD');
        this.coffeShopService.firstBookingDate = new Date(date.get('year'), date.get('month'), date.get('date'));
    }

    private proccessAdanceBookingRequest(booking, barbers, times) {
        if (typeof (times) != "undefined" && times != null && times.length > 0) {
            times = times.filter((timeObj) => timeObj.available).map(timeObj => {
                timeObj.date = moment(timeObj.date).format('HH:mm');
                return timeObj;
            });

            this.coffeShopService.bookingTimes = times;
            this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.some((time) => time.available) ? this.coffeShopService.bookingTimes.find((timeObject) => timeObject.available === true).date : '';
        }
        if (barbers) {
            this.coffeShopService.barbers = barbers;
        }
        if (!this.coffeShopService.allBarbers || !booking.date) {
            this.coffeShopService.allBarbers = barbers;
        }
    }

    public checkBarberIsFree(): void {

        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
        const today_time = `${timezoen.getHours() >= 10 ? timezoen.getHours() : `0` + timezoen.getHours()}:${timezoen.getMinutes() >= 10 ? timezoen.getMinutes() : `0` + timezoen.getMinutes()}`
        const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
        let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);

        const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
            `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;

        const barmen_adv_time_end = this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`] ?
            `${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[0]}:${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[1]}` : null;

        const barmen_has_andvanced_booking = !!this.coffeShopService.user.advanced_booking_hours;
        if (!barmen_has_andvanced_booking && !barmen_time_end && !this.coffeShopService.coffeShop.hours[`${today_day}`]) {
            //   this.disableContinueButton = true;
            this.errorMessage = 'Queue is full';
            return;
        }
        let time = null;
        let availableSlots = [];

        if (this.coffeShopService.user && (this.coffeShopService.user.current_queue_length > 0 || this.selectedBarber.today_advanced_bookings.length > 0)) {
            if (this.selectedBarber.todays_cancelled_bookings.length == 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
                let todayEndTime = this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`] != null ? this.coffeShopService.user.hours[`${today_day}`] : null;
                if (todayEndTime) {
                    let end = todayEndTime.split(":");
                    this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
                    let current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));

                    const lastQueue = new Date(nowMoment).setHours(Number(current_chair_time_with_cancelled.split(":")[0]), Number(current_chair_time_with_cancelled.split(":")[1]));
                    const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                    let differenceAdv = new Date(endTime).getTime() - new Date(lastQueue).getTime();
                    differenceAdv = Math.ceil(differenceAdv / 60000);
                    if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                        if (time == null)
                            time = current_chair_time_with_cancelled;
                        availableSlots.push({ date: current_chair_time_with_cancelled, available: true, booking_type: 1 });
                    }

                } else {

                    this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
                    time = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));
                    availableSlots.push({ date: time, available: true, booking_type: 1 });
                }
            } else if (this.todayBooking.length > 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
                let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
                if (durationElement) {
                    let newdate = new Date(new Date(new Date(durationElement.estimated_booking_time).setSeconds(0)).getTime() + durationElement.available_duration * 60000);

                    let todayEndTime = this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`] != null ? this.coffeShopService.user.hours[`${today_day}`] : null;
                    if (todayEndTime) {
                        let end = todayEndTime.split(":");
                        const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                        let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                        differenceAdv = Math.ceil(differenceAdv / 60000);
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                            if (time == null)
                                time = moment(newdate).format('HH:mm');
                            availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                        }
                        //  else {
                        //     this.errorMessage = 'Queue is full';
                        //     return;
                        // }
                    } else {
                        if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                            if (time == null)
                                time = moment(newdate).format('HH:mm');
                            availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                        }
                    }
                }
            }

            if (this.todayCancelledBooking.length > 0) {
                for (var element of this.todayCancelledBooking) {
                    let differenceAdv = new Date(this.currentTimeZone).getTime() - new Date(element.estimated_booking_time).getTime();
                    differenceAdv = Math.ceil(differenceAdv / 60000);
                    differenceAdv = element.available_duration - differenceAdv;
                    if (this.selectedServicesDuration <= element.available_duration && (new Date(timezoen).getTime() <= new Date(element.estimated_booking_time).getTime())) {
                        // if (this.selectedServicesDuration <= element.available_duration) {
                        let availableTime = element.estimated_chair_time_string.toString().toUpperCase().includes('AM') ?
                            this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('AM').join(' AM')) :
                            this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('PM').join(' PM'));
                        if (time == null) {
                            time = availableTime;
                        }
                        availableSlots.push({ date: availableTime, available: true, booking_type: 1 });

                    }
                    else if (this.selectedServicesDuration <= differenceAdv && new Date(timezoen).getTime() >= new Date(element.estimated_booking_time).getTime()) {
                        if (time == null) {
                            time = today_time;
                        }
                        availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                    }
                }
            }

            if (this.todayBooking[this.todayBooking.length - 1] && this.selectedBarber.today_advanced_bookings[0]) {
                let todayAdvanceBookings = this.selectedBarber.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
                let estimated_booking_time = this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].estimated_booking_time;
                let requested_booking_time = todayAdvanceBookings[0].requested_booking_time;
                let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
                let newdate = new Date(new Date(new Date(estimated_booking_time)).getTime() + durationElement.available_duration * 60000);
                if (durationElement) {
                    let difference = new Date(requested_booking_time).getTime() - new Date(newdate).getTime();
                    difference = difference / 60000;
                    if (this.selectedServicesDuration <= Math.ceil(difference)) {
                        if (time == null)
                            time = moment(newdate).format('HH:mm');
                        availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                    }
                }

                for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
                    if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
                        let upcomingadv = this.selectedBarber.today_advanced_bookings[index + 1].estimated_booking_time ? new Date(this.selectedBarber.today_advanced_bookings[index + 1].estimated_booking_time) : new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
                        let currentAdVTime = this.selectedBarber.today_advanced_bookings[index].estimated_booking_time ? this.selectedBarber.today_advanced_bookings[index].estimated_booking_time : this.selectedBarber.today_advanced_bookings[index].requested_booking_time;
                        let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
                        let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                            if (time == null)
                                time = moment(newdateAdvc).format('HH:mm');

                            availableSlots.push({ date: moment(newdateAdvc).format('HH:mm'), available: true, booking_type: 1 });
                        }
                    }
                }

                if (this.selectedBarber && this.selectedBarber.today_advanced_bookings && this.selectedBarber.today_advanced_bookings.length == 1) {
                    let durationElement: any = this.selectedBarber.today_advanced_bookings[0];
                    if (durationElement) {
                        if (barmen_adv_time_end) {
                            let end = barmen_adv_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        } else {
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }

                    }

                    if (barmen_time_end) {
                        let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                        if (durationElement) {
                            let end = barmen_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');

                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }
                }

                if (this.isBarberQueueFull(this.selectedBarber)) {
                    time = null;
                    availableSlots = [];
                }
            }

            if (this.coffeShopService.user.current_queue_length <= 0 && this.selectedBarber.today_advanced_bookings.length > 0) {
                if (barmen_time_end) {
                    if (today_time < barmen_time_end) {
                        let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[0].requested_booking_time);
                        let differenceAdv = new Date(upcomingadv).getTime() - new Date(nowMoment).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                            if (time == null)
                                time = today_time;

                            availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                        }
                    }
                }

                if (typeof (this.selectedBarber.today_advanced_bookings) != "undefined"
                    && this.selectedBarber.today_advanced_bookings != null
                    && this.selectedBarber.today_advanced_bookings.length > 1) {
                    let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                    if (durationElement) {
                        if (barmen_adv_time_end) {
                            let end = barmen_adv_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');

                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        } else {
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }

                        if (barmen_time_end) {
                            let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                            if (durationElement) {
                                let end = barmen_time_end.split(":");
                                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                                let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                                let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                                differenceAdv = differenceAdv / 60000;
                                if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                                    if (time == null)
                                        time = moment(newdate).format('HH:mm');

                                    availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                                }
                            }
                        }
                    }

                    for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
                        if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
                            let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
                            let newdateAdvc = new Date(new Date(new Date(this.selectedBarber.today_advanced_bookings[index].requested_booking_time)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
                            let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                                if (time == null)
                                    time = moment(newdateAdvc).format('HH:mm');

                                availableSlots.push({ date: moment(newdateAdvc).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }
                } else {
                    let durationElement: any = this.selectedBarber.today_advanced_bookings[0];
                    if (durationElement) {
                        if (barmen_adv_time_end) {
                            let end = barmen_adv_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        } else {

                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }

                        if (barmen_time_end) {
                            let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                            if (durationElement) {
                                let end = barmen_time_end.split(":");
                                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                                let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                                let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                                differenceAdv = differenceAdv / 60000;
                                if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                                    if (time == null)
                                        time = moment(newdate).format('HH:mm');

                                    availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                                }
                            }
                        }
                    }
                }
            }

            if (this.selectedBarber.today_advanced_bookings.length > 0) {
                let lastElement = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                let currentAdVTime = lastElement.estimated_booking_time ? lastElement.estimated_booking_time : lastElement.requested_booking_time;
                let newdate = new Date(new Date(new Date(currentAdVTime).setSeconds(0)).getTime() + lastElement.getDuration * 60000);
                let end = barmen_adv_time_end.split(":");
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                differenceAdv = differenceAdv / 60000;
                if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                    if (time == null)
                        time = moment(newdate).format('HH:mm');
                    availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                }
            }

        } else {
            if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
                let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                let end = todayEndTime.split(":");
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                let differenceAdv = new Date(endTime).getTime() - new Date(nowMoment).getTime();
                differenceAdv = Math.ceil(differenceAdv / 60000);
                if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                    if (time == null)
                        time = today_time;
                    availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                } else {
                    if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                        this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                        this.coffeShopService.selectedDate = now as any;
                    }
                    this.errorMessage = 'Queue is full';
                    return;
                }
            } else {
                if (barmen_time_end) {
                    if (today_time < barmen_time_end) {
                        time = today_time;
                        availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                    } else {
                        //this.errorMessage = 'Queue is full';
                        return;
                    }
                }
            }
            if (!barmen_time_end && this.coffeShopService.coffeShop.hours[`${today_day}`]) {

                const shop_hours_start = `${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[1]}`;
                const shop_hours_end = `${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[1]}`;
                if (today_time < shop_hours_start) { time = shop_hours_start; }
                if (today_time > shop_hours_start && today_time < shop_hours_end && this.coffeShopService.user.hours[`${today_day}`]) {
                    time = today_time;
                } else {
                    if (today_time > shop_hours_end) {
                        // this.disableContinueButton = true;
                        // this.errorMessage = 'Shop is closed';
                        //return;
                    }
                    if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                        this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                        this.coffeShopService.selectedDate = now as any;
                        // if(this.coffeShopService.bookingTimes.length == 0){
                        //     this.coffeShopService.bookingTimes.unshift({ date: today_time, available: true });
                        // }
                    }


                    if (this.coffeShopService.bookingTimes.length == 0 && this.coffeShopService.user.is_available) {
                        this.coffeShopService.bookingTimes.push({ date: today_time, available: true });
                        this.coffeShopService.selectedTime = today_time;
                    }
                    if (moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY') && !this.coffeShopService.user.is_available) {
                        this.errorMessage = 'Barber not available';
                    }

                    if (this.coffeShopService.bookingTimes.length == 0) {
                        this.isContinue = true;
                    }


                    // if(!this.coffeShopService.user.is_available){
                    //     this.errorMessage = 'Barber not available';
                    //     this.isContinue = true;
                    // }
                }
                if (today_time > shop_hours_end) {
                    //   this.disableContinueButton = true;
                    // this.errorMessage = 'Shop is closed';
                    return;
                }
            }
        }

        if (time) {
            let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
            if (this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) {
                if (this.coffeShopService.bookingTimes.length && this.coffeShopService.bookingTimes[0].date === time && availableSlots.length == 0) {
                    this.coffeShopService.bookingTimes[0].booking_type = 1;
                } else {
                    // this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
                    if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
                        let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
                        let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                        let start = todayStartTime.split(":")
                        let end = todayEndTime.split(":");
                        const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
                        const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                        if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
                            this.coffeShopService.selectedTime = time;
                            if (availableSlots.length > 0) {
                                this.coffeShopService.bookingTimes = [...availableSlots, ...this.coffeShopService.bookingTimes];
                                this.coffeShopService.bookingTimes = this.coffeShopService.bookingTimes.sort((a, b) => a.date.localeCompare(b.date));
                            } else {
                                this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
                            }
                        } else {
                            this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.length > 0 ? this.coffeShopService.bookingTimes[0].date : null;
                        }
                    }
                    this.coffeShopService.bookingTimes = this.removeDuplicates(this.coffeShopService.bookingTimes);
                    this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes[0].date;
                }
                // this.coffeShopService.selectedTime = time;
                this.coffeShopService.bookingType = 1;
                if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                    this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                    this.coffeShopService.selectedDate = now as any;
                }
                return;
            }

            if (((!this.coffeShopService.user.advanced_booking_hours || !this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) &&
                this.coffeShopService.user.hours[`${today_day}_start`]) || this.coffeShopService.coffeShop.hours[`${today_day}`]) {
                this.coffeShopService.bookingTimes = [];

                this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
                if (availableSlots.length > 0) {
                    this.coffeShopService.bookingTimes = [...availableSlots, ...this.coffeShopService.bookingTimes];
                    this.coffeShopService.bookingTimes = this.coffeShopService.bookingTimes.sort((a, b) => a.date.localeCompare(b.date));
                }
                this.coffeShopService.bookingType = 1;
                if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                    this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                    this.coffeShopService.selectedDate = now as any;
                }
                this.coffeShopService.bookingTimes = this.removeDuplicates(this.coffeShopService.bookingTimes);
                this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes[0].date;
            }
        } else {
            if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`] &&
                (this.coffeShopService.user.advanced_booking_hours && (typeof (this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) == "undefined" || this.coffeShopService.user.advanced_booking_hours[`${today_day}`] == null))) {
                let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
                let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                let start = todayStartTime.split(":")
                let end = todayEndTime.split(":");
                const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
                    this.coffeShopService.bookingTimes = [];
                    if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                        this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                        this.coffeShopService.selectedDate = now as any;
                    }
                }
            } else if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
                let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
                let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                let start = todayStartTime.split(":")
                let end = todayEndTime.split(":");
                const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
                    if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                        this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                    }
                }
            }
        }
    }

    removeDuplicates(bookings: any[]) {
        const uniqueBookings = bookings.reduce((accumulator: any, booking: any) => {
            const existingBooking = accumulator.find(
                (item) => item.date === booking.date && item.available === booking.available
            );

            if (!existingBooking) {
                accumulator.push(booking);
            }

            return accumulator;
        }, []);

        return uniqueBookings;
    }

    openCalendar() {
        let disableWeeks = [0, 1, 2, 3, 4, 5, 6];
        let enabledDays: any = [];
        const barbersData = [];
        const allHolidays = [];

        // this.coffeShopService.allBarbers.filter((barber) => barber.id == this.selectedBarber.id);

        let selectedBarber = this.coffeShopService.coffeShop.users.filter((barber) => barber.id == this.selectedBarber.id);
        if (this.coffeShopService.allBarbers != null && this.coffeShopService.allBarbers.length > 0) {
            const findIndesx = this.coffeShopService.allBarbers.findIndex((barber) => barber.id == this.selectedBarber.id);
            if (findIndesx !== -1 && (selectedBarber != null && selectedBarber.length > 0)) {
                selectedBarber[0].holiday = this.coffeShopService.allBarbers[findIndesx].holiday;
            }
        }

        // this.coffeShopService.allBarbers.forEach(barber => {
        let holidays = this.coffeShopService.daysConfig(selectedBarber[0]);
        let enabledDaysInAWeek = this.coffeShopService.enabledDaysInAWeek(selectedBarber[0]);

        barbersData.push({
            holidays: holidays.map(i => i.date),
            enabledWeekdays: enabledDaysInAWeek,
        });
        for (const h of holidays) {
            if (!allHolidays.find(i => i.date.getTime() === h.date.getTime())) {
                allHolidays.push(h);
            }
        }

        enabledDaysInAWeek.forEach((day, index) => {
            enabledDays.push(day);
        });
        // });

        const allTeamHolidays = [];
        for (const h of allHolidays) {
            const anyBarberAvailable = barbersData.find(i => this.isWorkingDay(i, h.date));
            if (!anyBarberAvailable) allTeamHolidays.push(h)
        }

        let options = this.coffeShopService.options();

        // Remove enabled days from the days to disable in the calendar
        enabledDays.forEach((day) => {
            // @ts-ignore
            if (disableWeeks.includes(day)) {
                let index = disableWeeks.indexOf(day);
                if (index !== -1) disableWeeks.splice(index, 1);
            }
        });
        const lastday: Date = options.to;
        let today: Date = options.from;
        const dates = [];
        while (today.getTime() <= lastday.getTime()) {
            const available = enabledDays.includes(today.getDay());
            dates.push({ date: today, available });
            today = new Date(today.getTime() + 86400000)
        }
        allTeamHolidays.forEach(element => {
            let index = dates.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment(element.date).format('DD/MM/YYYY'));
            if (index !== -1)
                dates[index].available = false;
        });

        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.shop.timezone.timezone }));
        let currentDay = moment(new Date()).format('dddd').toLowerCase();
        if (!this.selectedBarber.is_available && (this.shop.hours[currentDay] && moment(timezoen).format('HH:mm:ss') > this.shop.hours[currentDay])) {
            // if (!this.selectedBarber.is_available) {
            let index = dates.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'));
            if (index !== -1)
                dates[index].available = false;
        } else {
            if (this.selectedBarber.hours[currentDay]) {
                let index = dates.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'));
                if (index !== -1) {
                    dates[index].available = true;
                } else {
                    const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
                    //   dates.push({ date: today, available : true });
                    dates.push({ date: new Date(now), available: true });
                }
            }
        }

        this.coffeShopService.bookingDates = dates.filter((date) => date.available);
    }

    isWorkingDay(barberData, date) {
        const weekday = date.getDay();
        if (!barberData.enabledWeekdays.find(i => i === weekday)) {
            return false;
        }

        return !barberData.holidays.find(i => i.getTime() === date.getTime())
    }

    public dateIsEqual(date1: Date, date2: Date): boolean {
        date1 = new Date(date1); date2 = new Date(date2);
        return date1.getTime() === date2.getTime();
    }


    filterBarbersByAvailability(booking: { date: string, available: boolean }): Promise<boolean | HttpErrorResponse> {
        this.isContinue = false;
        this.coffeShopService.selectedTime = '';
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        if (booking.available === false || this.timeLoading || this.dateIsEqual((this.coffeShopService.selectedDate as any), (booking.date as any))) {
            return;
        }
        if (booking.date === this.coffeShopService.selectedDate && booking.date !== '') {
            this.coffeShopService.selectedDate = '';
            this.coffeShopService.selectedTime = '';
            return;
        }
        if (booking.date) {
            this.timeLoading = true;
            this.coffeShopService.selectedDate = booking.date;
            this.coffeShopService.bookingTimes = [];
            this.coffeShopService.selectedTime = '';
            this.errorMessage = '';
        }

        const formattedDate = booking.date ? this.coffeShopService.requestDateFormatter(booking.date) : booking.date;
        this.coffeShopService.advancedBookingRequest(booking, true)
            .pipe(concatMap((barbers: any) => {
                if (booking.date !== '') {
                    return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(formattedDate, this.selectedBarber)])
                } else {
                    return forkJoin([of(barbers), of(null)])
                }
            }))
            .subscribe(async ([barbers, times]: any) => {
                this.coffeShopService.bookingType = null;
                if (times == null) {
                    times = [];
                }

                if (times && times.length > 0) {
                    for (let Tindex = 0; Tindex < times.length; Tindex++) {
                        const element = times[Tindex];

                        if (element.available && times[times.length - 1] !== element) {
                            let duration = element.time_difference_in_minutes;
                            for (let index = Tindex + 1; index < times.length; index++) {
                                if (times[index].available) {
                                    duration += times[index].time_difference_in_minutes;
                                } else {
                                    break;
                                }
                            }

                            element.available = duration >= this.selectedServicesDuration;
                        } else if (times[times.length - 1] === element && element.available == true) {
                            element.available = element.time_difference_in_minutes >= this.selectedServicesDuration;
                        }
                    }
                }

                // Commented by kiran due to implement this in backend side 14/08/2023
                // try {
                //     await this.getBarberWithBookings().then(
                //         (res: any) => {
                //             this.advanceBookings = res;
                //             if (this.advanceBookings && this.advanceBookings.length > 0) {
                //                 this.advanceBookings = this.advanceBookings.sort((a: any, b: any) => {
                //                     return new Date(a.booking.requested_booking_time).getTime() - new Date(b.booking.requested_booking_time).getTime();
                //                 });

                //                 for (let index = 0; index < this.advanceBookings.length; index++) {
                //                     if (index != (this.advanceBookings.length - 1)) {
                //                         let upcomingadv = this.advanceBookings[index + 1].booking.estimated_booking_time ? new Date(this.advanceBookings[index + 1].booking.estimated_booking_time) : new Date(this.advanceBookings[index + 1].booking.requested_booking_time);

                //                         let currentAdVTime = this.advanceBookings[index].booking.estimated_booking_time ? this.advanceBookings[index].booking.estimated_booking_time : this.advanceBookings[index].booking.requested_booking_time;
                //                         let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.advanceBookings[index].booking.getDuration * 60000);
                //                         let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                //                         differenceAdv = differenceAdv / 60000;
                //                         if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                //                             times.push({ date: moment(newdateAdvc).format('YYYY-MM-DD HH:mm:ss'), available: true });
                //                         }
                //                     }
                //                 }
                //             }
                //         });
                // } catch (error) {

                // }

                // if ((times && times.length > 0) && this.selectedServicesDuration > this.shop.settings.advanced_bookings_time_interval) {
                //     let nextSlots = this.selectedServicesDuration / this.shop.settings.advanced_bookings_time_interval;
                //     let nextSlotsArray = nextSlots.toString().split(".");
                //     let noofSlots: number = 1;
                //     if (nextSlotsArray[1]) {
                //         noofSlots = (Number(nextSlotsArray[0]) + 1);
                //     } else {
                //         noofSlots = Number(nextSlotsArray[0]);
                //     }

                //     times.forEach((element, index) => {
                //         if (element.available && times[times.length - 1] !== element) {
                //             let nextElements = [];
                //             for (let t = 1; t < noofSlots; t++) {
                //                 if (times[(index + t)]) {
                //                     nextElements.push(times[(index + t)].available);
                //                 } else {
                //                     nextElements.push(false);
                //                 }
                //             }
                //             console.log("nextElements", nextElements);

                //             element.available = nextElements.some(res => res == false) ? false : true;
                //         }
                //     });
                // }

                // if ((times && times.length > 0) && this.todayBooking.length > 0) {
                //     times.forEach((element, index) => {
                //         this.todayBooking.forEach(todayBookings => {
                //             if (times[index + 1] && new Date(element.date) <= new Date(todayBookings.estimated_booking_time) && new Date(times[index + 1].date) >= new Date(todayBookings.estimated_booking_time)) {
                //                 element.available = false;
                //             }

                //             let newdate = new Date(new Date(new Date(todayBookings.estimated_booking_time)).getTime() + todayBookings.available_duration * 60000);
                //             if (times[index + 1] && new Date(element.date) <= (new Date(newdate)) && new Date(times[index + 1].date) >= new Date(newdate)) {
                //                 element.available = false;
                //             }
                //         });
                //     });
                // }

                if (times && times.length > 0) {
                    // times = this.CheckLastSlots(times);
                    // if(now === new Date(this.coffeShopService.selectedDate)){
                    //     times = this.CheckLastSlots(times);
                    // }
                    times = times.sort((a, b) => a.date.localeCompare(b.date));
                    times = this.removeDuplicates(times);
                }
                this.proccessAdanceBookingRequest(booking, barbers, times);
                // if ((booking.date as any).getTime() === new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime()
                //     && this.coffeShopService.coffeShop.has_active_barbers) {
                //     this.checkBarberIsFree();
                // }
                this.timeLoading = false;
            }, (error: HttpErrorResponse) => {
                this.timeLoading = false;
                this.errorMessage = 'Not available time for this day.';
            });
    }

    public selectTime(bookingTime: any): void {
        this.isContinue = false;
        if (!bookingTime.available || bookingTime.date === this.coffeShopService.selectedTime) { return; }
        this.coffeShopService.bookingType = bookingTime.booking_type ? bookingTime.booking_type : null
        bookingTime.date === this.coffeShopService.selectedTime ? this.coffeShopService.selectedTime = '' : this.coffeShopService.selectedTime = bookingTime.date;
    }


    isStaffQueueFull(staff, shopId) {
        if (staff.queue_full === 1 && staff.current_active_team === shopId && staff.current_queue_length === staff.current_queue_length_with_cancelled) return true;
        return false;
    }

    getavailableDuration() {
        if (this.selectedBarber.todays_cancelled_bookings.length > 0) {
            this.selectedBarber.todays_cancelled_bookings.forEach((booking: any) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.todayCancelledBooking.push(booking);
                });
            });
            this.todayCancelledBooking = this.todayCancelledBooking.sort((a, b) => {
                const timeA: any = new Date(a.estimated_booking_time);
                const timeB: any = new Date(b.estimated_booking_time);
                return timeA - timeB;
            });
        }
    }

    getAdvAvailableDuration() {
        if (this.selectedBarber.todays_booking.length > 0) {
            this.selectedBarber.todays_booking.forEach((booking: any) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.todayBooking.push(booking);
                });
            });
        }
    }

    appendServicesToBooking() {
        let count = this.selectedBarber.todays_cancelled_bookings.length - 1;
        return new Promise((resolve, reject) => {
            this.selectedBarber.todays_cancelled_bookings.forEach((booking, index) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.http.get(`/team/${this.shop.id}/members/${this.selectedBarber.id}/services?available_duration=${availableDuration}`)
                        .subscribe((services: any) => {
                            booking.full_services = services;
                            if (count === index) {
                                resolve(true)
                            }
                        }, (error) => {
                            reject(error);
                            this.errors = error;
                            this.apiErrorHandler.handleError(error)
                        });
                })
            });
        })
    }

    getAvailableDurationForCancelledBooking(booking) {
        return new Promise((resolve, reject) => {
            let serviceIds = [];

            booking.services.forEach((service) => {
                serviceIds.push(service.service_id);
            });

            this.http.get(`/bookings/${booking.id}/services/total-duration`)
                .subscribe((duration: any) => {
                    resolve(duration);
                }, (error) => {
                    reject(error);
                    this.errors = error;
                    this.apiErrorHandler.handleError(error)
                });
        })
    }

    isChairFree(current_chair_time_with_cancelled) {
        if (!this.shop || !current_chair_time_with_cancelled) {
            return false;
        }
        current_chair_time_with_cancelled = current_chair_time_with_cancelled.toUpperCase();
        let actualSelectedTime = current_chair_time_with_cancelled.includes('AM') ?
            this.coffeShopService.convert12to24(current_chair_time_with_cancelled.split('AM').join(' AM')) :
            this.coffeShopService.convert12to24(current_chair_time_with_cancelled.split('PM').join(' PM'));
        let nowMoment = this.convertTZ(new Date(), this.shop.timezone.timezone);
        let estimatedDateTime = new Date(nowMoment).setHours(Number(actualSelectedTime.split(":")[0]), Number(actualSelectedTime.split(":")[1]))
        if (new Date(this.currentTimeZone).getTime() >= new Date(estimatedDateTime).getTime()) {
            return true;
        }
        return false;
    }
    timeConvert(n) {
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return rhours < 0 ? rhours + " hr " + rminutes + " min" : rminutes + " min";
    }
}



// WEBPACK FOOTER //
// ./src/components/shop-queue/shop-queue.ts